import React, { type FC } from "react";
import { DateField, type DateFieldProps as SitecoreDateFieldProps } from "@sitecore-jss/sitecore-jss-react"; // eslint-disable-line no-restricted-imports
import { useSitecoreContext } from "../useSitecoreContext";
import { dateFormatter } from "~/foundation/Utils/dateFormatter";

type DateFieldProps = Partial<SitecoreDateFieldProps> & {
	format?: string;
};

const DateWrapper: FC<DateFieldProps> = (props) => {
	const { sitecoreContext } = useSitecoreContext();
	const newProps = { ...props };

	if (!newProps?.field && !sitecoreContext.pageEditing) {
		return <></>;
	}

	if (!newProps?.render) {
		newProps.render = date => {
			if (!date) {
				return "";
			}

			// if date field in Sitecore is empty, date will be januar 1, 0001
			return dateFormatter(
				date,
				sitecoreContext.custom.settings.isRtl,
				props.format || sitecoreContext.custom.settings.dateFormat
			)
		}
	}

	return <DateField {...newProps as SitecoreDateFieldProps} />;
};

export default DateWrapper;